import {Routes} from '@angular/router';

export const MANAGER_ROUTES: Routes = [
    {
        path: '',
        loadChildren:
        './modules/manager/list/list.module#ListModule'
    },
    {
        path: '',
        loadChildren:
        './modules/manager/resa/resa.module#ResaModule'
    }
];
